angular.module('NiacsProjectApp.services-project',[
  'NiacsProjectApp.filters',
  'NiacsProjectApp.services-general'
])
.factory('AutoSaveService',['$timeout','$rootScope',
  function($timeout,$rootScope) {
    var autoSaveInterval = 3000; // 3s
    var inAutoSave = false;

    function setTabindex() {
      var tabindex = 1,
          formElements = ['INPUT','TEXTAREA','SELECT'];
      $('input,textarea,select,a,button').each(function(){
        var e = $(this);
        if(formElements.indexOf(this.tagName) != -1 && this.type != 'hidden') {
          e.attr('tabindex',tabindex++);
        } else {
          e.attr('tabindex',-1);
        }
      });
    }

    var service = {
      startSaving: function() {
        inAutoSave = true;
        $rootScope.$broadcast('$autoSave.start');
      },
      isSaving: function() { return inAutoSave; },
      /**
       * Notify the service that a save operation has completed.
       * Optionally accepts a single argument that if set to true
       * will cause the notification to happen immediately, otherwise
       * a short display will be inserted so the user is sure to see feedback.
       */
      saveComplete: function() {
        if(arguments.length == 1 && arguments[0] === true) {
          inAutoSave = false;
        } else {
          // upon complete don't reset the flag immediately o/w
          // the save indicator flashes too quick.
          $timeout(function() {inAutoSave = false;}, 100);
        }
        $rootScope.$broadcast('$autoSave.complete');
        //setTabindex();
      },
      /**
       * Will store the callback as $autosave on the resource, will init a $keyup
       * method on the resource that can then be associated with ng-keyup events.
       *
       * @param  {ngResource}   resource The resource to setup auto-save on.
       * @param  {Function} callback A method to invoke when an object -is- to be saved.
       */
      setup: function(resource,callback) {
        //niacs.info("AutoSaveService.setup",resource);
        function getFieldvalue(resource) {
          // allow dot notation to be used to reference fields of nested objects.
          var value = resource;
          angular.forEach(resource.$autosave_field.split('.'),function(subField){
            if(value) {
              value = value[subField];
            }
          });
          return value;
        }
        resource.$autosave = function() {
          if(resource.$autosave_field && resource.$autosave_orig &&
             getFieldvalue(resource) == resource.$autosave_orig) {
            niacs.info('$autosave with unchanged value.');
            return;
          }
          inAutoSave = true;
          if(resource.$keyup_promise) {
            $timeout.cancel(resource.$keyup_promise);
          }
          callback();
        };
        resource.$focus = function(field,$event) {
          setTabindex();
          resource.$autosave_field = field;
          resource.$autosave_orig = getFieldvalue(resource);
          if($event && $event.target && $event.target.id && service.isSaving()) {
            // prevent keydown while saving
            $($event.target).addClass('disabled');
            $($event.target).bind('keydown',function(e){
              e.preventDefault();
            });
            // when the save completes start allowing keydown again.
            var stopListening = $rootScope.$on('$autoSave.complete',function() {
              $($event.target).unbind('keydown');
              stopListening();
              $($event.target).removeClass('disabled');
              $timeout(function() {
                $('#'+$event.target.id).focus();
              },250);
            });
          }
        };
        resource.$keyup = function($event) {
          if(resource.$keyup_promise) {
            $timeout.cancel(resource.$keyup_promise);
          }
          //auto save based on a timeout tends to be irritating and cause confusion
          //require user to change field focus instead.
          //resource.$keyup_promise = $timeout(resource.$autosave,autoSaveInterval);
        };
      }
    };
    return service;
}])
// lets controllers share the same project resource without roundtripping
// to the server and, more importantly, as a place to store contextual
// info e.g. project.$goals, etc.
.factory('ProjectService',['$http','$filter','$q','AutoSaveService','NotificationService','UserProfileService','NiacsProject','NiacsVulnAssmntRegion',
    function($http,$filter,$q,AutoSaveService,NotificationService,UserProfileService,NiacsProject,NiacsVulnAssmntRegion){
        var updateCount = 0; // just a var for watches that want to know when -anything- has changed.
        var getInProgress = false;
        var project = null;
        var listeners = {};
        var postSaveCbs = [];
        var projectLoaded = $q.defer();
        function setProject(p) {
            projectLoaded.resolve(project = p);
        }
        function notifyListeners() {
          for(var cid in listeners) {
            niacs.info("Notifying " + cid + " of project data arrival/change.");
            listeners[cid](project);
          }
        }
        function filterBySectors(hasSectorsArray) {
            var applicable_sectors = project.strategy_sources;
            if(!applicable_sectors || !applicable_sectors.length) {
                return hasSectorsArray; // just in case
            }
            return hasSectorsArray.filter(function(o){
                if(!o.sectors || !o.sectors.length) {
                    return true; // in case
                }
                return o.sectors.reduce(function(found,s){
                    return found||(applicable_sectors.indexOf(s) !== -1 ? true : false);
                },false);
            });
        }
        function loadCiStatements(varOrUnit) {
            var deferred = $q.defer();
            if(varOrUnit.$cistatements) {
              deferred.resolve(varOrUnit.$cistatements); // already loaded, do nothing.
            } else {
                varOrUnit.$getClimateImpacts()
                  .then(function(statements) {
                    varOrUnit.$cistatements = filterBySectors(statements);
                    if(project) {
                      project.$updateCount = updateCount++;
                    }
                    deferred.resolve(varOrUnit.$cistatements);
                  });
                /*
                // fetch general climate impact statements
                $http.get(varOrUnit._links.cistatements).success(function(data){
                    varOrUnit.$cistatements = filterBySectors(data.list);
                    if(project) {
                      project.$updateCount = updateCount++;
                    }
                    deferred.resolve(varOrUnit.$cistatements);
                });
                */
            }
            return deferred.promise;
        }
        // this loads only cistatements for units that are actually in use, not all possible units
        // in an attempt to save memory
        function loadUnitCiStatements(p) {
          var preDef = $filter('preFromUser')(p.units);
          angular.forEach(p.$vuln_region.$units,function(unit) {
            if(unit) {
              if(niacs.containsObjWithId(preDef,unit.id)) {
                loadCiStatements(unit);
              } else {
                delete unit.$cistatements; // in case a unit was removed.
              }
            }
          });
        }
        function finishProjectLoad(p) {
          setProject(p);
          project.$updateCount = updateCount;
          notifyListeners();
          getInProgress = false;
          if(p.vuln_region) {
              NiacsVulnAssmntRegion.get({id:p.vuln_region},function(region){
                p.$vuln_region = region;
                p.$updateCount = updateCount++;
                loadCiStatements(region);
                region.$getUnits()
                  .then(function(units) {
                    region.$units = filterBySectors(units);
                    p.$updateCount = updateCount++;
                    loadUnitCiStatements(p);
                  });
              });
            } else {
                // it's now valid to not have a VAR set, if a project doesn't
                // have one then just put in place what the UI expects of an empty VAR
                p.$vuln_region = {
                    $units: []
                };
            }
        }
        var activeSaves = [];
        var service = {
            /**
             * Used by the dashboard to get a user's list of projects.
             */
            list: function() {
              var def = $q.defer();
              UserProfileService.get(function(user) {
                NiacsProject.query({
                  "filter[uid.id][value]": user.id,
                  "page[limit]": 999,
                  sort: '-changed'
                },function(listResponse) {
                  def.resolve(listResponse.list);
                });
              });
              return def.promise;
            },
            /**
             * There are instances where logic disjoint from logic that initialized
             * a save needs to run code after a potential save completes.
             *
             * @param  {Function} cb callback to run after a save completes, or immediately if one isn't in process.
             */
            afterSave: function(cb) {
              if(AutoSaveService.isSaving()) {
                postSaveCbs.push(cb);
              } else {
                cb(project);
              }
            },
            save: function(p) {
              var toSave = (p||project);
              if(toSave) {
                var def = $q.defer(),
                    region = toSave.$vuln_region;
                var doSave = function() {
                  AutoSaveService.startSaving(); // in case the caller didn't do this.
                  toSave.$update(function(p){
                    AutoSaveService.saveComplete();
                    // while p === project Angular will have wiped out
                    // all $ prefixed variables with the update so restore
                    // them (the two used by the application)
                    p.$vuln_region = region;
                    p.$updateCount = updateCount++;
                    loadUnitCiStatements(p); // in case the units changed.
                    // the active save is always the first, delete it
                    activeSaves.splice(0,1);
                    def.resolve(toSave);
                    if(postSaveCbs.length) {
                      angular.forEach(postSaveCbs,function(cb){cb(p);});
                      postSaveCbs = [];
                    }
                  });
                };
                // add this save to the end of the active list
                activeSaves.push(def.promise);
                if(activeSaves.length > 1) {
                  //console.log('ProjectService.save waiting for '+(activeSaves.length-1)+' ongoing saves to complete');
                  activeSaves[activeSaves.length-2].then(doSave);
                } else {
                  // no current ongoing save, just run
                  doSave();
                }
                return def.promise;
              }
            },
            /**
             * Special function to expand a project that's in hand.
             * Used in read-only scenarios like LMS project review only.
             *
             * @param  {Project}   p        [description]
             * @param  {Function} callback [description]
             * @return {[type]}            [description]
             */
            expand: function(p,callback) {
              listeners['Expand'] = callback;
              finishProjectLoad(p);
            },
            get: function($routeParams,ctrlName,callback) {
              if(!$routeParams) {
                callback(project);
                return;
              }
              listeners[ctrlName] = callback;
              if(project) {
                  callback(project);
              } else if ($routeParams.id && !getInProgress) {
                  getInProgress = true;
                  NiacsProject.get({id:$routeParams.id},function(p){
                    if(p.version != niacs.PROJECT_VERSION) {
                      var origVersion = p.version;
                      while(p.version != niacs.PROJECT_VERSION) {
                        var migrator = niacs.migrators['m'+p.version.replace(/\./g, '_')];
                        if(!migrator) {
                          NotificationService.addError("Property "+p.label+" Require migration but unable to find migrator for version "+p.version);
                        }
                        migrator(p);
                      }
                      NotificationService.addInfo("Migrated Property "+p.label+" from version '"+origVersion+ "' to '"+p.version+"' <p>Your first edit will save the migrated version.</p>");
                    }
                    finishProjectLoad(p);
                  });
              }
            },
            setProject: setProject, // used during creation...
            /**
             * Initializes a project based on the contents of its $vuln_region property.
             * All units of the vulnerability assessment region will be added to the project.
             * This should only be invoked on a new project.
             * This does function NOT persist anything.
             *
             * @param  {Object} p           The project to initialize.
             * @return {Promise}  Will resolve promise immediately if p.$vuln_region isn't set, called with p.
             */
            initProject: function(p) {
              var deferred = $q.defer();

              if(p.$vuln_region) {
                setProject(p); // so sector filtering can work.
                service.addCiStatements(p,p.$vuln_region).then(function(p){
                  /* The niacs team has changed their mind (for now perhaps) that they don't want to
                   * pre-seed projects with units.  Leaving the code here commented out in case they
                   * change their minds.
                  $http.get(p.$vuln_region._links.units).success(function(units){
                    if(units && units.length > 0) {
                        angular.forEach(units,function(u){
                            service.addUnit(p,u).then(function(p){
                              if(p.units.length == units.length) {
                                deferred.resolve(p); // the two lengths will match only after all units have been added.
                              }
                            });
                        });
                    } else {
                      */
                      deferred.resolve(p); // no units to add resolve
                      /*
                    }
                  });*/
                });
              } else {
                deferred.resolve(p);
              }
              return deferred.promise;
            },
            /**
             * Generically adds all climate impact statements from a source to a destination.
             * @param {Object} destination The object to add all cistatements to (project or unit).
             * @param {Object} source An assessment region or unit.
             * @return {Promise} A promise to resolve upon completion, called with the destination object.
             */
            addCiStatements: function(destination,source) {
              var deferred = $q.defer();
              loadCiStatements(source).then(function(statements){
                niacs.debug("Adding all cistatements from ",source);
                if(statements) {
                  destination.cistatements = [];
                  angular.forEach(statements,function(statement){
                    destination.cistatements.push({id:statement.id});
                  });
                }
                deferred.resolve(destination);
              });
              return deferred.promise;
            },
            /**
             * functionality like "adding a unit" to a project isn't as simple as adding the
             * reference but requires that the project's unit reference automatically include all
             * climate impact statements as well, this is a redundant need (create time and edit time)
             * so making it part of a logical re-usable service.
             * This does function NOT persist anything.
             *
             * @param {Object} p The project to add the unit to (or null, use the current project).
             * @param {Object} u The unit to add.
             */
            addUnit: function(p,u) {
              var pjct = p||project,
                  unitRef = {id: u.id},
                  deferred = $q.defer();
              niacs.debug("Adding unit ", u);
              if(!pjct.units) {
                pjct.units = [];
              }
              if(u.id) {
                service.addCiStatements(unitRef,u).then(function(ref){
                  pjct.units.push(unitRef);
                  deferred.resolve(p);
                });
              } else {
                // custom unit, give it an id, push it and be done.
                u.id = niacs.guid();
                pjct.units.push(u);
                deferred.resolve(p);
              }
              return deferred.promise;
          },
          load: function() {
              return projectLoaded.promise;
          }
        };
        return service;
}]);
